module.exports = __webpack_public_path__ + "img/male.e72bb439.png";